import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";

actionsStyles.addToListButton = mergeToNew(actionsStyles.addToListButton, {
    variant: "primary",
});
